export const getStreetName = (streetName) =>
  streetName.charAt(0) === streetName.charAt(0).toUpperCase() &&
  !streetName.includes('р-он')
    ? `ул. ${streetName}`
    : streetName;
